import React from 'react';
import { Typography } from '@material-ui/core';
import Link from 'next/link';
import { Routes } from '€lib/routing';

const PasswordResetInvalid: React.FC = () => (
    <>
        <Typography>
            Your link has expired because it has not been used. Links expire within 24 hours and can
            only be used once.
        </Typography>

        <Link href={Routes.PasswordRecovery}>Request Another</Link>
    </>
);

export default PasswordResetInvalid;
